import controller from './controller';
import template from './template.html';

const controllerAs = 'singleLineResponsesViewCtrl';
const bindings = {
  ngModel: '=',
  answers: '=',
  disabled: '<'
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/forms/singleLineResponses/view/index.js